<ion-header>
  <ion-toolbar>
    <ion-title>Trip Summary</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="summary-container">
    <div class="header">
      <h1>Trip Summary</h1>
      <p class="date">{{ tripDate | date:'EEEE, MMM dd, yyyy' }}</p>
    </div>

    <!-- Map Container -->
    <div class="map-container" *ngIf="mapImageUrl">
      <img [src]="mapImageUrl" class="trip-map" alt="Trip Route">
    </div>

    <!-- Triple Detail Cards -->
    <div class="trip-details">
      <div class="detail-card">
        <ion-icon name="navigate-outline"></ion-icon>
        <div class="detail-info">
          <p class="label">Distance</p>
          <p class="value">{{ formattedDistance || '---' }}</p>
        </div>
      </div>
      <div class="detail-card">
        <ion-icon name="time-outline"></ion-icon>
        <div class="detail-info">
          <p class="label">Duration</p>
          <p class="value">{{ formattedDuration || '---' }}</p>
        </div>
      </div>
      <div class="detail-card">
        <ion-icon name="cash-outline"></ion-icon>
        <div class="detail-info">
          <p class="label">Fare</p>
          <p class="value">{{ formattedPrice || '---' }}</p>
        </div>
      </div>
    </div>

    <!-- Address Card -->
    <div class="trip-details-card">
      <ion-card>
        <ion-card-content>
          <ion-item lines="none" *ngIf="tripData?.Rider_Location">
            <ion-icon name="location-outline" slot="start" color="primary"></ion-icon>
            <ion-label>
              <h2>Pickup</h2>
              <p>{{ tripData.Rider_Location }}</p>
            </ion-label>
          </ion-item>
          <ion-item lines="none" *ngIf="tripData?.Destination">
            <ion-icon name="flag-outline" slot="start" color="danger"></ion-icon>
            <ion-label>
              <h2>Destination</h2>
              <p>{{ tripData.Destination }}</p>
            </ion-label>
          </ion-item>
        </ion-card-content>
      </ion-card>
    </div>

    <!-- Rating Section -->
    <div class="rating-section" [class.submitted]="ratingSubmitted">
      <h2>{{ ratingSubmitted ? 'Thank you!' : 'Rate your experience' }}</h2>

      <div class="star-rating">
        <ion-icon *ngFor="let num of [1, 2, 3, 4, 5]" [name]="rating >= num ? 'star' : 'star-outline'"
          [class.active]="rating >= num" (click)="!ratingSubmitted && setRating(num)">
        </ion-icon>
      </div>

      <ion-item lines="inset" *ngIf="!ratingSubmitted">
        <ion-textarea placeholder="Leave a comment about the rider..." [(ngModel)]="comment" rows="3">
        </ion-textarea>
      </ion-item>

      <div class="comment-display" *ngIf="ratingSubmitted && comment">
        <p>"{{ comment }}"</p>
      </div>

      <div class="buttons-container" *ngIf="!ratingSubmitted">
        <ion-button expand="block" (click)="submitRating()" class="submit-button">
          Submit Rating
        </ion-button>
        <ion-button expand="block" fill="clear" color="medium" (click)="skipRating()">
          Skip Rating
        </ion-button>
      </div>

      <ion-button *ngIf="ratingSubmitted" expand="block" color="success" (click)="dismiss()" class="continue-button">
        Continue
      </ion-button>
    </div>
  </div>
</ion-content>